<template>
    <div id="systemrole">
        <HrrBreadcrumb PMname="用户权限管理" CMname="角色管理" />
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="searchform">
                    <el-form-item label="角色名称">
                        <el-input v-model="searchform.roleName" placeholder="关键字"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick()" v-if="isHadFun('Add')">新增</el-button>
                    <el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick()" v-if="isHadFun('Update')">编辑</el-button>
                    <el-button type="primary" icon="el-icon-delete" size="small" @click="delclick()" v-if="isHadFun('Delete')">删除</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="tableData" border stripe highlight-current-row style="width: 100%" ref="moduletable" @cell-click="cellclick" @selection-change="selectionchange" v-loading="loading">
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column prop="roleName" label="角色名称" width="180">
                    </el-table-column>
                    <el-table-column prop="roleDesc" label="角色描述">
                    </el-table-column>
                    <el-table-column prop="creationDate" label="创建时间" width="180">
                    </el-table-column>
                    <el-table-column prop="creationBy" label="创建人" width="120">
                    </el-table-column>
                    <el-table-column prop="status" label="状态" width="80">
                        <template slot-scope="scope">
                            <el-tag  :type="scope.row.status?'primary':'danger'" disable-transitions>{{scope.row.status?'启用':'禁用'}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click.stop="RowFunManage(scope.row)" type="text" size="small" v-if="isHadFun('FunManage')">功能管理</el-button>
                            <el-button @click.stop="Rowview(scope.row)" type="text" size="small" v-if="isHadFun('See')">查看</el-button>
                            <el-button @click.stop="RowEdit(scope.row)" type="text" size="small" v-if="isHadFun('Update')">编辑</el-button>
                            <el-button @click.stop="Rowdelete(scope.row)" type="text" size="small" v-if="isHadFun('Delete')">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </template>
        </HrrMainLayout>
    </div>
</template>
<script>
    export default {
        name: 'system_role',
        data() {
            return {
                searchform: {
                    pageNum: 1,
                    pageSize: 10,
                    roleName: ""
                },
                tableData: [],
                total: 0,
                loading: true,
                selectionRows:[]
            }
        },
        methods: {
            onSubmit() {
                this.initData();
            },
            handleSizeChange(val) {
				this.searchform.pageSize=val;
				this.initData();
			},
			handleCurrentChange(val) {
				this.searchform.pageNum=val;
				this.initData();
			},
            Rowview(val) {
                const id = val.roleId;
                this.$route.meta.row = val;
                this.$route.meta.row.status_str=(val.status)?"启用":"禁用";
                this.$router.push({
                    path: '/system/role/view/' + id
                });
            },
            RowEdit(val) {
                const id = val.roleId;
                this.$route.meta.row = val;
                this.$router.push({
                    path: '/system/role/modify/' + id
                });
            },
            Rowdelete(val){
				this.$confirm("确定要删除 '"+val.roleName+"' ？","删除提示",{type:"warning"})
				.then(()=>{
					var Vuethis=this;
					this.$hrraxios({
                        method: "delete",
                        url:this.$api.system.role+"/"+val.roleId})
					.then((response)=>{
						var redata=response.data;
						if(redata.Success==true){
							Vuethis.$message({message:"删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							Vuethis.$message({message:redata.Prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});
			},
            Addclick() {
                this.$router.push({
                    path: '/system/role/add/',
                });
            },
            editclick(){
				if(this.selectionRows.length==0)
				{
					this.$message.warning("请先选择一行记录");
					return;
				}
				if(this.selectionRows.length>1)
				{
					this.$message.warning("只能操作一行记录");
					return;
				}
				this.$route.meta.row=this.selectionRows[0];
				this.$router.push({path:'/system/role/modify/'+this.selectionRows[0].roleId});
			},
            delclick(){
				if(this.selectionRows.length<1)
				{
					this.$message.warning("请先选择一行记录");
					return;
				}
				this.$confirm("确定要删除选中的角色？","删除提示",{type:"warning"}).then(()=>{
					var Vuethis=this;
					this.selectionRows.forEach(row=>{
						this.$hrraxios({
                        method: "delete",
                        url:this.$api.system.role+"/"+row.roleId})
						.then((response)=>{
							Vuethis.loading = false;
                            var data = response.data;
                            if (data.Success == true) {
                                Vuethis.$message.success("已删除");
                                this.initData();
                            } else {
                                Vuethis.$message.error(data.Prompt);
                            }
						})
						.catch((error)=>{
                            console.log(error);
						})
					});
				}).catch(()=>{

				});
			},
			cellclick(row, column, cell, event){
				this.$refs.moduletable.toggleRowSelection(row);
			},
			selectionchange(selection){
				this.selectionRows=selection;
			},
            initData() {
                var Vuethis = this;
                this.loading = true;
                this.$hrraxios.get(this.$api.system.roleList, {
                        params: this.searchform
                    })
                    .then(function(response) {
                        Vuethis.loading = false;
                        var data = response.data;
                        if (data.Success == true) {
                            Vuethis.tableData = data.Data.List;
                            Vuethis.total = data.Data.Total;
                        } else {
                            Vuethis.$message.error(data.Prompt);
                        }
                    })
                    .catch(function(error) {
                        Vuethis.loading = false;
                        console.log(error);
                    });
            },
            RowFunManage(val){
                const id = val.roleId;
                this.$route.meta.row = val;
                this.$router.push({
                    path: '/system/role_fun/' + id
                });
            }
        },
        beforeRouteLeave(to, from, next) {
            // 导航离开该组件的对应路由时调用
            to.meta.row = from.meta.row;
            next();
        },
        created() {
            this.$common.getFunListByMCode(this,"SystemRole",()=>{
				this.initData();
			});
        }
    }

</script>
